'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var R = require('ramda');

var queryLens = R.lensProp('query');
/**
 * Update location query using given transformer
 * @param {Function} transformer
 * @param {Object} location
 * @returns {Object} Transformed location
 * @example
 *   <Link to={updateQuery(R.dissoc('popup'))} />
 */

function updateQuery(transformer, location) {
  if (typeof location === 'undefined') {
    return function (location) {
      return updateQuery(transformer, location);
    };
  }

  return R.over(queryLens, transformer, location);
}

exports.updateQuery = updateQuery;
//# sourceMappingURL=update-query.js.map
